// MegaMenu JavaScript - Vanilla JS (No jQuery Required)
var megaMenu = (function() {
  'use strict';
  
  var selectors = {
    megaMenu: '.mega-menu',
    megaMenuDetails: 'details.mega-menu',
    megaMenuSummary: '.mega-menu summary',
    megaMenuContent: '.mega-menu__content',
    headerSection: '#shopify-section-header',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavActiveDropdown: '.site-nav--active'
  };

  var config = {
    activeClass: 'site-nav--active',
    megaActiveClass: 'mega-menu--active',
    hoverDelay: 150,
    closeDelay: 500, // Aumentato per dare più tempo di movimento
    animationDuration: 200
  };

  var cache = {
    header: null,
    headerHeight: 0,
    initialized: false
  };

  var state = {
    activeMenu: null,
    hoverTimer: null,
    closeTimer: null
  };

  // Utility: Debounce function
  function debounce(func, wait) {
    var timeout;
    return function executedFunction() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  // Utility: Throttle function
  function throttle(func, limit) {
    var inThrottle;
    return function() {
      var args = arguments;
      var context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(function() { inThrottle = false; }, limit);
      }
    };
  }

  // Utility: Query selector helper
  function qs(selector, parent) {
    return (parent || document).querySelector(selector);
  }

  function qsAll(selector, parent) {
    return Array.from((parent || document).querySelectorAll(selector));
  }

  function updateDimensions() {
    cache.header = qs(selectors.headerSection);
    cache.headerHeight = cache.header ? cache.header.offsetHeight : 0;
  }

  function cacheSelectors() {
    updateDimensions();
  }

  function init() {
    if (cache.initialized) {
      return;
    }

    cacheSelectors();
    bindEvents();
    setupAccessibility();
    cache.initialized = true;
  }

  function bindEvents() {
    // Attach hover events directly to each mega menu element
    qsAll(selectors.megaMenuDetails).forEach(function(megaMenuEl) {
      var content = megaMenuEl.querySelector(selectors.megaMenuContent);
      
      megaMenuEl.addEventListener('mouseenter', function() {
        clearTimeout(state.closeTimer);
        state.hoverTimer = setTimeout(function() {
          showMegaMenu(megaMenuEl);
        }, config.hoverDelay);
      });

      megaMenuEl.addEventListener('mouseleave', function() {
        clearTimeout(state.hoverTimer);
        state.closeTimer = setTimeout(function() {
          hideMegaMenu(megaMenuEl);
        }, config.closeDelay);
      });
      
      // IMPORTANTE: Traccia anche l'hover sul content per evitare chiusure
      if (content) {
        content.addEventListener('mouseenter', function() {
          clearTimeout(state.closeTimer);
          clearTimeout(state.hoverTimer);
        });
        
        content.addEventListener('mouseleave', function() {
          state.closeTimer = setTimeout(function() {
            hideMegaMenu(megaMenuEl);
          }, config.closeDelay);
        });
      }
    });

    // Gestione click sui summary (toggle)
    document.body.addEventListener('click', function(e) {
      var summaryEl = e.target.closest(selectors.megaMenuSummary);
      if (summaryEl) {
        handleSummaryClick(e, summaryEl);
      }
    });

    // Chiudi con ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeAllMenus();
      }
    });

    // Update dimensions on resize (throttled)
    window.addEventListener('resize', throttle(function() {
      updateDimensions();
    }, 100));

    // Chiudi menu quando si clicca fuori
    document.body.addEventListener('click', function(e) {
      if (!e.target.closest(selectors.megaMenu + ', ' + selectors.siteNavHasDropdown)) {
        closeAllMenus();
      }
    });
  }

  function setupAccessibility() {
    // Aggiungi attributi ARIA ai mega menu
    qsAll(selectors.megaMenuSummary).forEach(function(summary) {
      var details = summary.closest('details');
      var content = details.querySelector(selectors.megaMenuContent);
      var menuId = 'mega-menu-' + Math.random().toString(36).substr(2, 9);
      
      summary.setAttribute('aria-expanded', 'false');
      summary.setAttribute('aria-haspopup', 'true');
      summary.setAttribute('aria-controls', menuId);
      summary.setAttribute('role', 'button');
      
      if (content) {
        content.setAttribute('id', menuId);
        content.setAttribute('role', 'region');
        content.setAttribute('aria-label', 'Submenu');
      }
    });
  }

  function handleSummaryClick(e, summaryEl) {
    var details = summaryEl.closest('details');
    var isOpen = details.hasAttribute('open');
    
    // Previeni comportamento default
    e.preventDefault();
    e.stopPropagation();
    
    // Cancella tutti i timer hover per evitare conflitti
    clearTimeout(state.hoverTimer);
    clearTimeout(state.closeTimer);
    
    if (isOpen) {
      hideMegaMenu(details);
    } else {
      closeAllMenus();
      showMegaMenu(details);
    }
  }

  function showMegaMenu(detailsEl) {
    if (!detailsEl) return;
    
    closeAllMenus();
    
    detailsEl.classList.add(config.megaActiveClass);
    detailsEl.setAttribute('open', '');
    updateDimensions();
    
    var content = detailsEl.querySelector(selectors.megaMenuContent);
    var summary = detailsEl.querySelector('summary');
    
    if (content) {
      content.style.display = 'block';
      content.style.opacity = '0';
      
      // Smooth fade in
      setTimeout(function() {
        content.style.transition = 'opacity ' + config.animationDuration + 'ms ease';
        content.style.opacity = '1';
      }, 10);
    }
    
    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }
    
    state.activeMenu = detailsEl;
  }

  function hideMegaMenu(detailsEl) {
    if (!detailsEl) return;
    
    detailsEl.classList.remove(config.megaActiveClass);
    
    var content = detailsEl.querySelector(selectors.megaMenuContent);
    var summary = detailsEl.querySelector('summary');
    
    if (content) {
      content.style.opacity = '0';
      
      setTimeout(function() {
        detailsEl.removeAttribute('open');
        content.style.display = '';
      }, config.animationDuration);
    } else {
      detailsEl.removeAttribute('open');
    }
    
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
    
    if (state.activeMenu === detailsEl) {
      state.activeMenu = null;
    }
  }

  function closeAllMenus() {
    clearTimeout(state.hoverTimer);
    clearTimeout(state.closeTimer);
    
    // Chiudi tutti i mega menu aperti
    qsAll(selectors.megaMenuDetails + '[open]').forEach(function(details) {
      hideMegaMenu(details);
    });
    
    // Chiudi dropdown classici se esistono
    qsAll(selectors.siteNavActiveDropdown).forEach(function(el) {
      el.classList.remove(config.activeClass);
    });
  }

  function destroy() {
    if (!cache.initialized) return;
    
    closeAllMenus();
    
    // Rimuovi attributi ARIA
    qsAll(selectors.megaMenuSummary).forEach(function(summary) {
      summary.removeAttribute('aria-expanded');
      summary.removeAttribute('aria-haspopup');
      summary.removeAttribute('aria-controls');
      summary.removeAttribute('role');
    });
    
    cache.initialized = false;
  }

  // API pubblica
  return {
    init: init,
    destroy: destroy,
    cacheSelectors: cacheSelectors,
    closeAllMenus: closeAllMenus,
    _config: config,
    _cache: cache,
    _state: state
  };
})();

// Auto-inizializzazione
(function() {
  var initialized = false;
  
  function initialize() {
    if (!initialized) {
      initialized = true;
      megaMenu.init();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();